import React from 'react';
// eslint-disable-next-line import/no-named-as-default
import toast, {
  resolveValue,
  Toaster as HotToaster,
  ToasterProps,
  ToastIcon,
  ToastType,
} from 'react-hot-toast';
import { Alert } from 'react-bootstrap';
import styled from '@emotion/styled';
import IcoMoonIcon from 'tradevan-ui/IcoMoonIcon';
import { IcoMoonIconsEnum } from 'tradevan-ui/IcoMoonIcon/svg';
import { WarningIcon } from './WarningIcon';

/** 結合 bootstrap <Alert /> & react-hot-toast <ToastBar /> */
export const ToastBsAlert = styled(Alert)`
  display: flex;
  align-items: center;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
  margin: 0;
`;

/** react-hot-toast 預設 message style */
export const Message = styled('div')`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`;

/** react-hot-toast 的 type 轉換為 bootstrap Alert 的 variant */
export const typeTrans = (type: ToastType) => {
  switch (type) {
    case 'success':
      return 'success';
    case 'error':
      return 'danger';
    case 'loading':
      return 'loading';
    /** blank 視為 warning */
    case 'blank':
      return 'warning';
    case 'custom':
    default:
      return 'dark';
  }
};

/** 狀態列
 *  - blank 視為 warning */
const Toaster = (props: ToasterProps): JSX.Element => (
  <HotToaster
    position="top-right"
    toastOptions={{ duration: 300000 }}
    {...props}
  >
    {(t) => (
      <ToastBsAlert
        variant={typeTrans(t.type)}
        style={{ opacity: t.visible ? 1 : 0 }}
      >
        {t.type === 'blank' ? <WarningIcon /> : <ToastIcon toast={t} />}
        <Message {...t.ariaProps}>{resolveValue(t.message, t)}</Message>
        {t.type !== 'loading' && (
          <IcoMoonIcon
            icon={IcoMoonIconsEnum.Xmark}
            onClick={() => {
              toast.dismiss(t.id);
            }}
            style={{ opacity: 0.2 }}
          />
        )}
      </ToastBsAlert>
    )}
  </HotToaster>
);

export default Toaster;
